// Debugging confirmation
console.log('✅ Categories Page Builder loaded successfully!');

// Categories Page Builder
export async function buildContentCategoriesPage() {
  console.log(`🏗️ Categories Page Builder - Starting Building Categories Page`);

  try {
    // Parallel import of all dependencies
    const [
      { buildMasterPageByMasterLayoutBuildManager },
      { getRegularPageLayoutContentByFolderPath },
      { buildComponentCatalogCategories, buildComponentCatalogCategoriesHeaderTags },
      { isNodeEnvironment },
    ] = await Promise.all([
      import(
        /* webpackChunkName:"build-manager-master-pages", webpackPrefetch: true */ '../js/build-manager-master-pages.js'
      ),
      import(
        /* webpackChunkName:"build-manager-utils", webpackPrefetch: true */ '../js/build-manager-utils.js'
      ),
      import(
        /* webpackChunkName:"catalog-categories", webpackPrefetch: true */ '../builders-components/catalog/catalog-categories.js'
      ),
      import(
        /* webpackChunkName:"utils-fetch-data-json", webpackPrefetch: true */ '../js/utils-fetch-data-json.js'
      ),
    ]);

    // Fetch layouts concurrently
    const [masterLayout, pageLayout, pageComponent, pageHeaderTags] = await Promise.all([
      buildMasterPageByMasterLayoutBuildManager('master-layout-shop'),
      getRegularPageLayoutContentByFolderPath('pages/catalog-pages/category'),
      buildComponentCatalogCategories(),
      buildComponentCatalogCategoriesHeaderTags(),
    ]);

    // Insert component into page layout
    const content = pageLayout.replace('{{{ content }}}', pageComponent);

    // if (!isNodeEnvironment()) {
    // Client-side rendering structure
    const masterLayoutX = `<div id="x-my-page-layout">${masterLayout}</div>`;
    const pageContentX = `<div id="x-my-page-content">${content}</div>`;

    console.log(`🔄 buildContentCategoriesPage Builder - Finished (Client-side)`);
    return {
      masterPageName: 'master-layout-shop',
      masterPageHtml: masterLayoutX,
      pageContentHtml: pageContentX,
      pageHeaderTags: pageHeaderTags,
    };
    //} else {
    //    // Server-side rendering
    //    const result = masterLayout.replace("{{{ content }}}", content);

    //    console.log(`🔄 buildContentCategoriesPage Builder - Finished (Server-side)`);
    //    return result;
    //}
  } catch (error) {
    console.error('❌ Error building Categories page content:', error);
    return 'Error loading Categories page content.';
  }
}
